<template>
    <div>
        <vs-button v-on:click="resolveRequest" class="text-bold">RESOLVE</vs-button>
    </div>
</template>

<script>
    import RestService from "../../services/RestService";

    export default {
        name: 'CellRendererButton',
        /*data: {
            resolved: false
        },*/
        methods: {
            async resolveRequest() {
                const resolveRequestResponse = await RestService.resolveRequest(this.params.data.uuid);
                if (resolveRequestResponse.success) {
                    this.$parent.$listeners.resolveRequest(true);
                } else {
                    // TODO handle if error
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .resolved-text {
        font-style: italic;
    }
</style>
